import Color from 'color'
import { createUseStyles } from 'react-jss'

import { facebookBlue, instagramOrange, black, lightGrey } from '../../../styles/const/colors'
import { transitionShort } from '../../../styles/const/common'

const getTitleColor = color => {
  switch (color) {
    case 'blue':
      return facebookBlue
    case 'orange':
      return instagramOrange
    default:
      return black
  }
}

const useStyles = createUseStyles(theme => ({
  checkbox: {
    position: 'relative'
  },
  checkboxInput: {
    width: 0,
    height: 0,
    opacity: 0,
    position: 'absolute',
    '&:checked + label:after': {
      backgroundColor: theme.brandPrimary
    },
    '&:not(:checked) + label:after': {
      height: ({ isPartiallyChecked }) => isPartiallyChecked && 2,
      backgroundColor: ({ isPartiallyChecked }) => isPartiallyChecked && theme.brandPrimary
    },
    '&:hover:not([disabled]) + label:before': {
      borderColor: Color(lightGrey).darken(0.1).rgb().string()
    }
  },
  checkboxLabel: {
    display: 'block',
    minWidth: ({ isLarge }) => (isLarge ? 24 : 16),
    minHeight: ({ isLarge }) => (isLarge ? 24 : 16),
    cursor: 'pointer',
    '&:before, &:after': {
      content: '""',
      position: 'absolute',
      cursor: 'pointer',
      boxSizing: 'border-box'
    },
    '&:before': {
      border: ({ isLarge }) => (isLarge ? `3px solid ${lightGrey}` : `2px solid ${lightGrey}`),
      backgroundColor: 'white',
      borderRadius: 2,
      top: ({ centerVertically }) => (centerVertically ? '50%' : 0),
      transform: ({ centerVertically }) => centerVertically && 'translateY(-50%)',
      left: 0,
      width: ({ isLarge }) => (isLarge ? 24 : 16),
      height: ({ isLarge }) => (isLarge ? 24 : 16)
    },
    '&:after': {
      top: ({ isLarge, centerVertically }) => (centerVertically ? '50%' : isLarge ? 6 : 4),
      transform: ({ centerVertically }) => centerVertically && 'translateY(-50%)',
      left: ({ isLarge }) => (isLarge ? 6 : 4),
      width: ({ isLarge }) => (isLarge ? 12 : 8),
      height: ({ isLarge }) => (isLarge ? 12 : 8),
      backgroundColor: 'transparent',
      transition: transitionShort
    }
  },
  checkboxTitle: {
    paddingLeft: ({ isLarge }) => (isLarge ? 38 : 24),
    paddingTop: ({ isLarge }) => (isLarge ? 4 : 0),
    paddingBottom: ({ isLarge }) => (isLarge ? 4 : 0),
    fontSize: ({ isLarge }) => (isLarge ? 16 : 'inherit'),
    fontWeight: ({ isBoldTitle }) => (isBoldTitle ? 700 : 400),
    color: ({ titleColor, disabled }) => (disabled ? lightGrey : getTitleColor(titleColor)),
    lineHeight: '16px' // helps to vertically center the title and avoid adding spacing issues for container
  },
  checkboxBody: {
    paddingLeft: ({ isLarge }) => (isLarge ? 38 : 24),
    '& p': {
      marginTop: 8
    },
    '& > *:first-child': {
      marginTop: 0
    },
    '& > *:last-child': {
      marginBottom: 0
    }
  }
}))

export default useStyles
